import * as React from "react";

export const LANDSCAPE = "landscape" as const;
export const PORTRAIT = "portrait" as const;

export type Orientation = "portrait" | "landscape";

const OrientationContext: React.Context<Orientation> = React.createContext<Orientation>(LANDSCAPE);
export default OrientationContext;
